@if (authService.isImpersonating()) {
  <div
    class="impersonation-banner"
    role="status"
    aria-live="polite"
    data-impersonating="true"
  >
    <div class="impersonation-banner__inner">
      <div class="impersonation-banner__blocks">
        <div class="impersonation-banner__account">
          <svg class="impersonation-banner__icon impersonation-banner__icon--account" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
          </svg>
          <div class="impersonation-banner__text">
            <span class="impersonation-banner__label">{{ 'shared.banner.account_owner' | translate }} ({{ accountOwnerRoleLabel }})</span>
            <div class="impersonation-banner__name-line">
              {{ displayName }}
              @if (userEmail) {
                <span class="impersonation-banner__email">({{ userEmail }})</span>
              }
            </div>
          </div>
        </div>
        @if (connectedAdmin) {
          <div class="impersonation-banner__admin">
            <svg class="impersonation-banner__icon impersonation-banner__icon--admin" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"></path>
            </svg>
            <div class="impersonation-banner__text">
              <span class="impersonation-banner__label">{{ 'shared.banner.connected_admin' | translate }}</span>
              <div class="impersonation-banner__name-line">
                {{ connectedAdmin.name }}
                <span class="impersonation-banner__email">({{ connectedAdmin.email }})</span>
              </div>
            </div>
          </div>
        }
      </div>
      <button
        type="button"
        class="impersonation-banner__leave"
        (click)="onLeaveSession()"
        [attr.aria-label]="'shared.banner.leave_session_aria' | translate"
      >
        {{ 'shared.banner.leave_session' | translate }}
      </button>
    </div>
  </div>
}
